export const imageURL = "https://zepul-org-vc8ofu8.s3.ap-south-1.amazonaws.com/";
